import * as React from "react";
import { Box, Skeleton, Card, useTheme } from "@mui/material";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";

import AvatarList from "../../../../AvatarList";
import CustomAvatar from "../../../../CustomAvatar";
import CustomCircleButton from "../../../../CustomCircleButton";

const TableLoadingCart = ({ type }) => {
  const theme = useTheme();

  return (
    <>
      {Array(3)
        .fill("")
        .map((e, i) => {
          return (
            <Card
              key={i}
              sx={{
                padding: "16px",
                border: "2px solid",
                borderColor: "black.main",
                boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
                borderRadius: "16px",
                maxHeight: "156px",
                marginBottom: "24px",
                cursor: "pointer",
              }}
            >
              <Box sx={{ overflow: "hidden", display: "flex", py: "2px" }}>
                <CustomAvatar size={64} round={"8px"} />
                <Box
                  sx={{
                    width: "80%",
                    display: "flex",
                    flexDirection: "column",
                    ml: "8px",
                  }}
                >
                  <Skeleton width='100%' height={30} />

                  <Box
                    sx={{
                      mt: "auto",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "end",
                    }}
                  >
                    <Skeleton width={30} height={10} />
                    <Skeleton width={40} height={10} />
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  borderTop: "2px solid",
                  borderColor: "black.main",
                  marginTop: "16px",
                  paddingTop: "8px",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <AvatarList size={35} />

                  <Box
                    sx={{ width: "24px", height: "24px", textAlign: "right" }}
                  >
                    <CustomCircleButton
                      width='22px'
                      height='22px'
                      bgColor='primary.main'
                      hoverBgColor='primary.main'
                      hoverColor='black.main'
                      hoverBorder={`none`}
                      bShadow={`0px 2px 0px ${theme.palette.black.main}`}
                      activeBgColor='black.main'
                      activeColor='white.main'
                    >
                      <KeyboardArrowRightRoundedIcon
                        sx={{ pl: "2px", fontSize: 20 }}
                      />
                    </CustomCircleButton>
                  </Box>
                </Box>
              </Box>
            </Card>
          );
        })}
    </>
  );
};
export default TableLoadingCart;
